<template>
  <PanelCard :title="I18n.t('user.form.title')">
    <div class="tw-w-80">
      <SfInput
        :id="`${idPrefix}-name`"
        v-model="name"
        :label="I18n.t('common.name')"
        :placeholder="I18n.t('user.panel.name_placeholder')"
        :has-error="nameErrors.length > 0"
        :error-text="nameErrors"
        data-testid="user-panel-name"
      />
    </div>
    <div class="tw-w-80">
      <SfInput
        :id="`${idPrefix}-email`"
        v-model="email"
        :label="I18n.t('common.email')"
        :placeholder="I18n.t('user.panel.email_placeholder')"
        :disabled="!capabilities.emailEditable"
        :helper-text="emailHint"
        :has-error="emailErrors.length > 0"
        :error-text="emailErrors"
        data-testid="user-panel-email"
      />
    </div>
    <div v-if="languageVisible" class="tw-w-80">
      <PanelDropdown
        v-model="locale"
        :label="I18n.t('common.language')"
        :options="capabilities.localeOptions"
        data-testid="user-panel-locale"
      />
    </div>
    <div v-if="creating" class="tw-flex tw-flex-col tw-gap-1">
      <SfCheckbox
        v-model="sendWelcomeMail"
        :label="I18n.t('user.send_welcome_mail')"
        data-testid="user-panel-send-welcome-mail"
      />
      <span class="tw-pl-6 tw-text-sm tw-text-sf-slate-light-2">
        {{ I18n.t('user.send_welcome_mail_option_hint') }}
      </span>
    </div>
  </PanelCard>
</template>

<script setup lang="ts">
import { computed, useId } from 'vue'
import { storeToRefs } from 'pinia'

import { useUserPanelStore } from '@app/application/user-management/stores/user-panel'
import useI18n from '@app/shared/vue/composables/use-I18n'
import PanelCard from '@app/application/user-management/components/panel-card.vue'
import PanelDropdown from '@app/application/user-management/components/user-panel/panel-dropdown.vue'
import { SfCheckbox, SfInput } from '@silverfin/ui-components'

defineOptions({ name: 'UserDetailsSection' })

const I18n = useI18n()
const store = useUserPanelStore()
const { capabilities, creating, emailErrors, languageVisible, nameErrors } =
  storeToRefs(store)
const idPrefix = useId()

const name = store.draftField('name')
const email = store.draftField('email')
const locale = store.draftField('locale')
const sendWelcomeMail = store.draftField('sendWelcomeMail')

const emailHint = computed(() =>
  capabilities.value.vismaConnectFirm
    ? I18n.t('user.panel.email_visma_connect_hint')
    : ''
)
</script>
